export default __webpack_public_path__ + "static/media/sangam.60248009.JPG";